<template>
    <q-btn
            v-if="isGranted('RESOLVE_POST')"
            :color="color"
            :label="label"
            :loading="isLoading"
            :title="title"
           @click="resolve"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { Post } from '@/type';
import notify from '@/components/notify';
import { resolve } from './post';

interface Data {
  task: Promise<Post>|null,
  isLoading: boolean,
}

export default defineComponent({
  props: {
    postId: {
      type: Number,
      required: true,
    },
    moveToTimeline: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      isLoading: false,
    };
  },
  computed: {
    color(): string {
      return this.moveToTimeline ? 'primary' : 'positive';
    },
    label(): string {
      return this.moveToTimeline ? 'Resolve & Timeline' : 'Resolve';
    },
    title(): string {
      return this.moveToTimeline ? 'Resolve the post & move it to timeline' : 'Resolve post';
    },
  },
  methods: {
    resolve() {
      this.isLoading = true;
      this.task = resolve(this.postId, this.moveToTimeline);
      this.task.then(() => {
        let message = 'Post has been resolved';
        message += this.moveToTimeline ? ' & moved to timeline.' : '.';
        notify(message);
      });
      this.task.finally(() => {
        this.isLoading = false;
      });
    },
    isGranted,
  },
});
</script>
